import { TooltipProps } from "antd";
import React, { FC } from "react";
import { InfoIco } from "../../../assets/customIcons";
import { ITooltip } from "../ITooltip";
import styles from "./TooltipWithInfoIcon.module.scss";

export type ITooltipWithIcon = {
  className?: string;
  padding?: string;
} & TooltipProps;

export const TooltipWithInfoIcon: FC<ITooltipWithIcon> = ({ padding, ...props }) => {
  return (
    <ITooltip {...props}>
      <InfoIco className={styles.icon} style={{padding}}/>
    </ITooltip>
  );
};
